import { EstadoPuertoNap, Naps } from "@/shared/interfaces"
import { Grid } from "@mui/material"

type Props = {
    nap: Naps
}
export const ContarPuertosNap = (puertos: any[]) => {
    console.log({puertos})
    let OCUPADO = 0;
    let DISPONIBLE = 0;
    puertos?.forEach(p =>{
        if(p.estado === EstadoPuertoNap.OCUPADO 
            || p.estado === EstadoPuertoNap.EN_USO 
            || p.estado === EstadoPuertoNap.BLOQUEADO){
            OCUPADO++;
        }
        if(p.estado === EstadoPuertoNap.DISPONIBLE
            || p.estado === EstadoPuertoNap.LIBRE){
            DISPONIBLE++;
        }
    })
    return { OCUPADO: OCUPADO, DISPONIBLE: DISPONIBLE };
}

const SemaforoPuertos = ({
    nap
}: Props) => {
    const { OCUPADO } = ContarPuertosNap(nap?.puertos || []);
    const totalPuertos = nap?.puertos?.length || 0
    const calculateColor = () => {
        const puertos_disponibles = nap?.puertos_disponibles || 0
        const puertos_ocupados = nap?.puertos_ocupados || 0
        if(totalPuertos !== (puertos_disponibles+puertos_ocupados)){
            console.log(`Incosistencia con puertos de NAP ${nap?.nombre} (cbase)`)
        }

        
        if(totalPuertos !== (puertos_disponibles+puertos_ocupados)){
            console.log(`Incosistencia con puertos de NAP ${nap?.nombre} (cbase vs cpuertos)`)
        }
        const porcentaje = (OCUPADO/totalPuertos)*100
        if(porcentaje<40){
            return "#108500"
        }
        if(porcentaje<75){
            return "#FAFF00"
        }
        if(porcentaje<=100){
            return "#FF0000"
        }
        return ""
    }
    return (<>
        <Grid container alignItems="center" alignContent="center" justifyContent="center">
            <Grid container alignItems="center" alignContent="center" justifyContent="center">
                <span style={{
                    backgroundColor:calculateColor(), 
                    width:25, height:25, borderRadius:"50%", 
                    boxShadow:"0px 0px 3px 0px #000"}}/>
            </Grid>
            <Grid container alignItems="center" alignContent="center" justifyContent="center">
                <span>{OCUPADO}/{totalPuertos} PUERTOS</span>
            </Grid>
        </Grid>
    </>)
}

export default SemaforoPuertos